import React from 'react';
import styled from 'styled-components';
import { getColors, getSizes } from '~/common/utils/product';
import { ProductSettings } from '~/sections/product/SelectionControls';
import { Variant } from '~/types/product';
import { ColorItem, Item, ItemDisplayContainer } from './Item';
import { StarColorItem } from '../StarColorItem';

interface SelectionControlProps {
  variants: Array<Variant>;
  selectedColor: string;
  selectedSize: string;
  setProductSettings: React.Dispatch<React.SetStateAction<ProductSettings>>;
  isFlashSale?: boolean;
}

const ColorItems = ({
  variants,
  setProductSettings,
  selectedColor,
  selectedSize,
  isFlashSale,
}: SelectionControlProps) => {
  const colors = getColors(selectedSize, variants) || [];

  return (
    <ItemDisplayContainer>
      {colors.map((colorObj) => (
        <ColorItemWrapper
          key={colorObj.color}
          selected={colorObj.color === selectedColor}
          available={colorObj.available}
          isFlashSale={isFlashSale}
          onClick={() => {
            const sizesByColor = getSizes(colorObj.color, variants) || [];
            const selectedSize = sizesByColor.find(
              (size) => size.available,
            )?.size;

            setProductSettings((prev) => ({
              ...prev,
              selectedColor: colorObj.color,
              selectedSize: selectedSize || '',
            }));
          }}
        >
          {isFlashSale ? (
            <ColorItem
              color={colorObj.color.split(' - ')[0] || colorObj.color}
              available={colorObj.available}
              selected={colorObj.color === selectedColor}
            />
          ) : (
            <StarColorItem
              color={colorObj.color.split(' - ')[0] || colorObj.color}
              available={colorObj.available}
              selected={colorObj.color === selectedColor}
            />
          )}
        </ColorItemWrapper>
      ))}
    </ItemDisplayContainer>
  );
};

const ColorItemWrapper = styled('div')<{
  available: boolean;
  selected: boolean;
  isFlashSale?: boolean;
}>`
  width: 45px;
  position: relative;
  transition: transform 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    background: ${({ isFlashSale }) =>
      isFlashSale ? '#F0A0BF' : 'transparent'};
    transform: scale(0.95);
  }

  ${({ selected, isFlashSale }) =>
    selected &&
    `
      background: ${isFlashSale ? '#F0A0BF' : 'transparent'};
    `}
`;

export default ColorItems;
